import React from 'react'
import clsx from 'clsx'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode
  footer?: React.ReactNode
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, header, footer, children, ...props }, ref) => (
    <div
      ref={ref}
      className={clsx('overflow-hidden rounded-xl border border-stone-300 bg-stone-100 shadow-sm', className)}
      {...props}
    >
      {header && <div className="border-b border-stone-300 px-6 py-4">{header}</div>}
      <div className="px-6 py-4">{children}</div>
      {footer && <div className="border-t border-stone-300 px-6 py-4">{footer}</div>}
    </div>
  )
)

Card.displayName = 'Card'
